export function handleUpdateNewResponse(payload) {
  return {
    type: "UPDATE_NEW_RESPONSE",
    payload
  };
}

export function addButtonLabelLanguage(languageCode) {
  return {
    type: "ADD_BUTTON_LABEL_LANGUAGE_TO_NEW_RESPONSE",
    languageCode
  };
}

export function deleteButtonLabelLanguage(languageCode) {
  return {
    type: "DELETE_BUTTON_LABEL_LANGUAGE_TO_NEW_RESPONSE",
    languageCode
  };
}

export function handleAddTag(tagId) {
  return {
    type: "ADD_TAG_TO_NEW_RESPONSE",
    tagId
  };
}

export function handleRemoveTag(tagId) {
  return {
    type: "REMOVE_TAG_FROM_NEW_RESPONSE",
    tagId
  };
}
